import { render, staticRenderFns } from "./NewsroomCard.vue?vue&type=template&id=4b4be56f"
import script from "./NewsroomCard.vue?vue&type=script&lang=js"
export * from "./NewsroomCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports